export const REQUEST_STATUS = {
  SUCCESS: 'success',
  PENDING: 'pending',
};
